import cx from 'classnames';

import {TestAttribute} from 'components/TestAttribute';

type Props = {
    title: string;
    description?: string;
    hideableTitle?: boolean;
    className?: string;
}
export const PageHeader: React.FC<Props> = ({title, description, className, hideableTitle = true}: Props) => (
    <div className={cx(className, 'tw-mb-4')}>
        <TestAttribute testAttribute={{id: 'page-title'}}>
            <div className={cx('tw-mt-0 lg:tw-block tw-mb-2 tw-ts-h2-bold', {['tw-hidden']: hideableTitle})}>
                {title}
            </div>
        </TestAttribute>
        <div>{description}</div>
    </div>
);
